import React from 'react';
import { PiCheckLight, PiXLight, PiWarningLight } from 'react-icons/pi';
import { useTranslation } from 'react-i18next';
import Button from '../../shared/TailwindComponents/Button';
import ModalShell from '../../shared/ModalShell';

interface UnsavedChangesModalProps {
  isOpen: boolean;
  onSave: () => void;
  onDiscard: () => void;
  isLoading?: boolean;
}

const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({
  isOpen,
  onSave,
  onDiscard,
  isLoading = false
}) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <ModalShell
      isOpen={isOpen}
      // No dismiss path: the user must choose save or discard.
      onClose={() => undefined}
      closeOnBackdrop={false}
      hideCloseButton
      title={t('Unsaved changes')}
      icon={<PiWarningLight />}
      size="sm"
      footer={
        <>
          <Button
            variant="neutral"
            onClick={onDiscard}
            disabled={isLoading}
            icon={<PiXLight className="w-4 h-4" />}
            className="flex-1 justify-center"
          >
            {t('Discard changes')}
          </Button>
          <Button
            variant="primary"
            onClick={onSave}
            disabled={isLoading}
            isLoading={isLoading}
            icon={<PiCheckLight className="w-4 h-4" />}
            className="flex-1 justify-center"
          >
            {t('Save changes')}
          </Button>
        </>
      }
    >
      <p className="text-sm text-fg-body">
        {t('You have unsaved changes in this spreadsheet. Would you like to save them before leaving?')}
      </p>
    </ModalShell>
  );
};

export default UnsavedChangesModal;
